<script setup lang="ts">
import CounterBadge from '@/components/micro/CounterBadge.vue'

interface Option {
  optValue: string
  optLabel?: string
  optIcon?: string
  copyable?: boolean
  disabled?: boolean
}

interface OptionGroup {
  optGroupLabel: string
  options: Option[]
}

const props = withDefaults(defineProps<{
  actionKey: string
  icon: string
  tooltip?: string
  theme?: string
  counter?: number
  options?: (Option | OptionGroup)[]
  disabled?: boolean
}>(), {
  tooltip: '',
})

const emit = defineEmits<{
  (e: 'action', value: string): void
}>()

function handleMainTrigger() {
  if (props.options) return

  emit('action', props.actionKey)
}

function handleOptionClick(opt: Option) {
  emit('action', opt.optValue)
}
</script>

<template>
  <sword-popover-wuk
    class="relative inline-block"
    :distance="10"
    :disabled="!options"
    placement="bottom-end"
  >
    <template #default="{ shown }">
      <sword-tooltip>
        <sword-button-wuk
          :icon="icon"
          :theme="theme ?? (shown ? 'tertiary' : 'white')"
          :disabled="disabled"
          round
          :data-ui-action="actionKey"
          :aria-label="`click to ${$t(tooltip)}`"
          @click.native="handleMainTrigger"
        />
        <counter-badge :value="counter" />
        <template #tooltip>
          {{ $t(tooltip) }}
        </template>
      </sword-tooltip>
    </template>

    <template #content>
      <sword-list
        key="send-link-options"
        v-close-popper
        class="w-[17.5rem] py-4"
        :options="options"
        align-left
        @click="handleOptionClick"
      />
    </template>
  </sword-popover-wuk>
</template>
